<elder-basic-pane-layout class="full">
  <form #capabilitiesFrm="ngForm" class="flex layout-row gap-md scroll-fix">
    <elder-pane class="flex-none">
      <elder-pane-header>
        <elder-pane-title>{{ 'capabilities.capabilities' | translate }}</elder-pane-title>
      </elder-pane-header>

      <elder-pane-content>
        <elder-nav-list
          style="width: 250px; height: 100%"
          [value]="selectedCapability$ | async"
          [compareWith]="compare"
          (valueChange)="selectedCapability = $event"
        >
          @for (capability of capabilities$ | async; track capability) {
            <elder-nav-link [value]="capability">
              <span>{{ capability.name }}</span>
            </elder-nav-link>
          }
        </elder-nav-list>
      </elder-pane-content>
    </elder-pane>

    <!-- Main container -->
    <elder-pane class="flex">
      <elder-pane-header>
        <elder-pane-title>
          {{ (selectedCapability$ | async)?.name }}
        </elder-pane-title>

        <elder-pane-actions>
          <button mat-icon-button [disabled]="!capabilitiesFrm.form.valid" (click)="onSave($event)">
            <mat-icon>save</mat-icon>
          </button>

          <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="true">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <!--
            <button mat-menu-item
              (click)="onDelete($event)"
              [disabled]="!deletionEnabled">
              <mat-icon>delete</mat-icon>
              <span>{{'actions.delete' | translate}}</span>
            </button>
            -->
          </mat-menu>
        </elder-pane-actions>
      </elder-pane-header>

      <elder-pane-content>
        <app-capability-detail
          class="flex"
          [capability]="selectedCapability$ | async"
        ></app-capability-detail>
      </elder-pane-content>
    </elder-pane>
  </form>
</elder-basic-pane-layout>
